<template>
  <div class="extra-accesses-component">
    <div class="column is-8-desktop is-10-tablet is-12-mobile is-offset-2-desktop is-offset-1-tablet is-offset-0-mobile">
      <div class="columns">
        <div class="column is-full">
          <p class="is-size-1 is-size-3-mobile has-text-centered has-text-grey-dark dm-sans">
            Quantos acessos você vai criar no Pedbot?
          </p>
        </div>
      </div>
      <div class="choose-partners">
        <div class="columns mt-4">
          <div class="column is-full is-flex is-justify-content-center is-align-content-center">
            <div class="select is-large is-primary is-one-quarter-desktop is-half-mobile">
              <select class="has-text-centered" v-model="extraAccesses.quantity">
                <option disabled selected>Selecionar</option>
                <option :value="number+1" v-for="(number) in accessesQuantity" :key="number">
                  {{ number+1 }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="columns mt-6 mt-4-mobile">
          <div class="column is-full">
            <p class="is-size-4 is-size-5-mobile has-text-centered has-text-grey-dark dm-sans">
              Cobramos um valor de R$ {{ formatPrice(extraAccesses.entity.price) }}/mês por acesso extra
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import extraAccessesApi from '@/apis/extraAccesses'
import { useAppStore } from "@/stores/AppStore";

export default {

  name: 'extra-accesses',

  data() {
    return {
      extraAccesses: {
        quantity: null,
        entity: {}
      },
      isMobile: false
    }
  },

  props: {
    formData: {
      required: true,
      type: Object
    }
  },

  watch: {
    'formData.plan': {
      handler() {
        this.getAccesses()
      },
      deep: true
    },
    'extraAccesses.quantity': function (quantity) {
      this.setExtraAccesses(quantity)
    }
  },

  computed: {
    accessesQuantity() {
      const array = [...Array(1000).keys()]
      let count = 0
      while (count < (this.formData.plan.data.max_accesses - 1)) {
        array.shift()
        count++
      }
      return array
    }
  },

  methods: {
    cleanData() {
      this.extraAccesses.quantity = null
    },
    formatPrice(value) {
      return (parseFloat(value).toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' }))
          .replace('R$', '').trim();
    },
    setExtraAccesses(quantity) {
      if (quantity === null) {
        return;
      }
      this.formData.extraAccesses.data = []
      const extraAccess = JSON.parse(JSON.stringify(this.extraAccesses.entity))
      extraAccess.quantity = quantity
      // if (this.formData.messagePacket.data.mode === 2) {
      //   this.formData.messagePacket.data.quantity = quantity
      //   this.formData.messagePacket.data.price = ((parseFloat(this.formData.messagePacket.data.originalPrice) * quantity)).toString()
      // }
      const appStore = useAppStore()
      appStore.showReviewNextButton = true
      
      // Abrir sidebar automaticamente no mobile
      if (window.innerWidth < 1024) {
        appStore.isMobileSidebarVisible = true;
      }
      
      // Rolar para a seção de resumo do plano
      this.scrollToPlanSummary();
      
      if (quantity === this.formData.plan.data.max_accesses) {
        extraAccess.price = 0
        this.formData.extraAccesses.showStep = false
        this.formData.extraAccesses.data = {}
        return;
      } else {
        this.formData.extraAccesses.showStep = true
        extraAccess.price = (parseFloat(this.extraAccesses.entity.price) * (quantity - this.formData.plan.data.max_accesses))
      }
      extraAccess.price = extraAccess.price.toString()

      this.formData.extraAccesses.data = extraAccess
    },
    async getAccesses() {
      if (this.formData.plan.data.id) {
        this.extraAccesses.entity = await extraAccessesApi.get({
          plan_id: this.formData.plan.data.id
        })
      }
    },
    checkScreenSize() {
      this.isMobile = window.innerWidth < 768;
    },
    scrollToPlanSummary() {
      // Timeout para garantir que a DOM será atualizada primeiro
      setTimeout(() => {
        // Em dispositivos móveis, o resumo está na parte inferior da página
        if (window.innerWidth < 1024) {
          // Elemento de resumo no modo mobile
          const reviewElement = document.querySelector('.mobile-summary-container');
          if (reviewElement) {
            reviewElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } else {
            // Alternativa: rolar para o final da página
            window.scrollTo({
              top: document.body.scrollHeight,
              behavior: 'smooth'
            });
          }
        } else {
          // Em desktop, o resumo está na sidebar à direita
          const sidebarElement = document.querySelector('.review-sidebar-component');
          if (sidebarElement) {
            const topPosition = sidebarElement.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({
              top: topPosition - 80, // Ajuste para considerar a navbar
              behavior: 'smooth'
            });
          }
        }
      }, 100);
    }
  },
  
  mounted() {
    this.getAccesses();
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  
  beforeUnmount() {
    window.removeEventListener('resize', this.checkScreenSize);
  }

}

</script>

<style lang="scss" scoped>
.extra-accesses-component {
  .select {
    transition: all 0.3s ease;
    
    select {
      border-radius: 6px;
      
      &:focus {
        box-shadow: 0 0 0 0.125em rgba(72, 95, 199, 0.25);
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .extra-accesses-component {
    .is-size-3-mobile {
      font-size: 1.5rem !important;
    }
    
    .is-size-5-mobile {
      font-size: 1rem !important;
    }
    
    .mt-4-mobile {
      margin-top: 1rem !important;
    }
    
    .select.is-large {
      height: auto;
      
      select {
        font-size: 1rem;
        height: 2.5rem;
        padding-left: 1rem;
        padding-right: 2.5rem;
      }
    }
  }
}

@media screen and (max-width: 400px) {
  .extra-accesses-component {
    .select.is-large {
      select {
        font-size: 0.9rem;
        height: 2.25rem;
        padding-left: 0.75rem;
        padding-right: 2rem;
      }
    }
  }
}
</style>
